import React, { useState, useCallback } from "react";
import "./CrearNuevoNegocio.scss";
import Input from "../../components/atoms/Input/Input";
import iconNombreEmpresa from "../../assets/icons/icon_nombre_empresa_inact.png";
import iconNombreAgente from "../../assets/icons/icon_nomb_gerente_encarg_inact.png";
import iconCorreo from "../../assets/icons/icon_correo_inact.png";
import iconTelefono from "../../assets/icons/icon_telefono_inact.png";
import iconDireccion from "../../assets/icons/icon_ubicacion_inact.png";
import iconPostalCode from "../../assets/icons/icon_c_postal_inact.png";
import iconRazonSocial from "../../assets/icons/icon_razon_social_inact.png";
import iconSeleccionTipo from "../../assets/icons/icon_selec_tipo_inact.png";
import iconRFC from "../../assets/icons/icon_rfc_inact.png";
import iconPlan from "../../assets/icons/icon_plan_inact.png";
import iconDespedidaTiket from "../../assets/icons/icon_msj_ticket_inact.png";
import iconDiasGratis from "../../assets/icons/icon_dia_gratis_inact.png";
// import InputImagen from "../../components/atoms/InputImagen/InputImagen";
import CardView from "../../components/molecules/CardView/CardView";
import Button from "../../components/atoms/Button/Button";
import ValidationMessage from "../../components/atoms/ValidationMessage/ValidationMessage";
import { validateData } from "../../utiles/ValidateEntries";
import { toast, Toaster } from "sonner";
import {
    getPlan,
    getTypeBusiness,
    registerBusiness,
} from "../../services/businnes";
import Select from "../../components/atoms/Select/Select";
import FileUpload from "../../components/atoms/FileUpload/FileUpload";

// Estado inicial del formulario
const INITIAL_BUSINESS_STATE = {
    businessName: "",
    owner: "",
    email: "",
    phoneNumber: "",
    address: "",
    zipCode: "",
    rfc: "",
    companyName: "",
    typeBusinessId: "",
    ticketMessage: "",
    planId: "",
    freeDays: "",
};

// Opciones de días gratis
const FREE_DAYS_OPTIONS = [
    { id: 0, name: "Sin días gratis" },
    { id: 7, name: "7 días" },
    { id: 14, name: "14 días" },
    { id: 30, name: "30 días" },
    { id: 60, name: "60 días" },
    { id: 90, name: "90 días" },
    { id: 120, name: "120 días" },
    { id: 180, name: "180 días" },
    { id: 365, name: "1 año" },
    { id: 730, name: "2 años" },
    { id: -1, name: "Personalizado" },
];

const CrearNuevoNegocio = () => {
    // Estado del formulario
    const [business, setBusiness] = useState(INITIAL_BUSINESS_STATE);
    const [emptyField, setEmptyField] = useState({});
    const [plan, setPlan] = useState([]);
    const [businessType, setBusinessType] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);

    // Manejador de cambios en inputs
    const handleChange = useCallback((e) => {
        const { name, value } = e.currentTarget;
        setBusiness((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    }, []);

    // Manejador de cambios en selects
    const handleSelectChange = useCallback((name, value) => {
        setBusiness((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    }, []);

    // Manejador de cambio de imagen
    const handleImageChange = useCallback((file) => {
        setImageFile(file);
        console.log("Imagen seleccionada:", file?.name);
    }, []);

    // Resetear formulario
    const resetForm = useCallback(() => {
        setBusiness(INITIAL_BUSINESS_STATE);
        setEmptyField({});
        setImageFile(null);
    }, []);

    // Manejador del envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación de campos
        const { status, emptyFields } = validateData(business);
        setEmptyField(emptyFields);

        if (!status) {
            toast.error("Validación fallida", {
                description: "Por favor, completa todos los campos requeridos.",
                position: "top-right",
                duration: 4000,
            });
            return;
        }

        setIsLoading(true);
        const toastId = toast.loading("Procesando solicitud...", {
            position: "top-right",
        });

        try {
            // Crear FormData para enviar datos con imagen
            const formData = new FormData();

            // Agregar todos los campos del negocio al FormData
            Object.keys(business).forEach((key) => {
                formData.append(key, business[key]);
            });

            // Agregar la imagen si existe
            if (imageFile) {
                formData.append("logo", imageFile);
            }

            const response = await registerBusiness(formData);

            if (!response.success) {
                toast.error("Error al crear negocio", {
                    description:
                        response.message || "Ocurrió un error inesperado",
                    position: "top-right",
                    duration: 5000,
                    icon: "⚠️",
                    id: toastId,
                });
                return;
            }

            // Éxito - Limpiar formulario
            toast.success("¡Éxito!", {
                description: response.message || "Negocio creado correctamente",
                position: "top-right",
                duration: 5000,
                icon: "🎉",
                id: toastId,
            });

            resetForm();
        } catch (error) {
            console.error("Error inesperado:", error);
            toast.error("Error crítico", {
                description:
                    "Ocurrió un error inesperado. Por favor intenta nuevamente.",
                position: "top-right",
                duration: 5000,
                id: toastId,
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Obtener planes
    const getPlans = useCallback(async () => {
        if (plan.length > 0) return;

        try {
            const response = await getPlan();
            if (response.success) {
                setPlan(response.data);
            }
        } catch (error) {
            console.error("Error al obtener los planes:", error);
            toast.error("Error al cargar planes", {
                description: "No se pudieron cargar los planes disponibles",
                position: "top-right",
            });
        }
    }, [plan.length]);

    // Obtener tipos de negocio
    const getTypeBusiness_ = useCallback(async () => {
        if (businessType.length > 0) return;

        try {
            const response = await getTypeBusiness();
            if (response) {
                setBusinessType(response);
            }
        } catch (error) {
            console.error("Error al obtener los tipos de negocio:", error);
            toast.error("Error al cargar tipos de negocio", {
                description:
                    "No se pudieron cargar los tipos de negocio disponibles",
                position: "top-right",
            });
        }
    }, [businessType.length]);

    return (
        <CardView className="crear-negocio-wrapper">
            <h3 className="crear-negocio__title">Crear nuevo negocio</h3>
            <div className="crear-negocio">
                <aside className="crear-negocio__sidebar">
                    <div className="crear-negocio__image-upload">
                        <FileUpload
                            variant="card"
                            accept="image/*"
                            onChange={handleImageChange}
                            label="Subir imagen del negocio"
                            maxSize={5} // 5MB máximo
                        />
                    </div>
                    {/* <div className="crear-negocio__info-card">
                        <h4 className="crear-negocio__info-title">
                            Restaurante
                        </h4>
                        <div className="crear-negocio__plan-details">
                            <div className="crear-negocio__plan-item">
                                <div className="crear-negocio__plan-subtitle">
                                    Plan
                                </div>
                                <div className="crear-negocio__plan-description">
                                    Planes
                                </div>
                            </div>
                            <div className="crear-negocio__plan-item">
                                <div className="crear-negocio__plan-subtitle">
                                    $4,600
                                </div>
                                <div className="crear-negocio__plan-description">
                                    Precio MXN
                                </div>
                            </div>
                            <div className="crear-negocio__plan-item">
                                <div className="crear-negocio__plan-subtitle">
                                    91
                                </div>
                                <div className="crear-negocio__plan-description">
                                    Dispositivos
                                </div>
                            </div>
                        </div>
                    </div> */}
                </aside>

                <form className="crear-negocio__form" onSubmit={handleSubmit}>
                    <ValidationMessage>
                        <Input
                            text="Nombre del Negocio *"
                            name="businessName"
                            value={business.businessName}
                            onChange={handleChange}
                            show={emptyField.businessName}
                            icon={iconNombreEmpresa}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Input
                            text="Nombre del Dueño Encargado *"
                            name="owner"
                            value={business.owner}
                            onChange={handleChange}
                            show={emptyField.owner}
                            icon={iconNombreAgente}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Input
                            text="Correo de usuario"
                            name="email"
                            value={business.email}
                            onChange={handleChange}
                            show={emptyField.email}
                            icon={iconCorreo}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Input
                            text="Teléfono"
                            type="number"
                            name="phoneNumber"
                            value={business.phoneNumber}
                            onChange={handleChange}
                            show={emptyField.phoneNumber}
                            icon={iconTelefono}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Input
                            text="Dirección"
                            name="address"
                            value={business.address}
                            onChange={handleChange}
                            show={emptyField.address}
                            icon={iconDireccion}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Input
                            text="Código Postal"
                            name="zipCode"
                            value={business.zipCode}
                            onChange={handleChange}
                            show={emptyField.zipCode}
                            icon={iconPostalCode}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Input
                            text="RFC"
                            name="rfc"
                            value={business.rfc}
                            onChange={handleChange}
                            show={emptyField.rfc}
                            icon={iconRFC}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Input
                            text="Nombre de la Empresa"
                            name="companyName"
                            value={business.companyName}
                            onChange={handleChange}
                            show={emptyField.companyName}
                            icon={iconRazonSocial}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Select
                            text="Selecciona el tipo de negocio"
                            name="typeBusinessId"
                            value={business.typeBusinessId}
                            setValue={(value) =>
                                handleSelectChange("typeBusinessId", value)
                            }
                            show={emptyField.typeBusinessId}
                            onClick={getTypeBusiness_}
                            options={businessType}
                            icon={iconSeleccionTipo}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Input
                            text="Mensaje Ticket"
                            name="ticketMessage"
                            value={business.ticketMessage}
                            onChange={handleChange}
                            show={emptyField.ticketMessage}
                            icon={iconDespedidaTiket}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Select
                            text="Plan Seleccionado"
                            name="planId"
                            value={business.planId}
                            setValue={(value) =>
                                handleSelectChange("planId", value)
                            }
                            show={emptyField.planId}
                            options={plan}
                            icon={iconPlan}
                            onClick={getPlans}
                        />
                    </ValidationMessage>

                    <ValidationMessage>
                        <Select
                            text="Días gratis"
                            name="freeDays"
                            value={business.freeDays}
                            setValue={(value) =>
                                handleSelectChange("freeDays", value)
                            }
                            show={emptyField.freeDays}
                            options={FREE_DAYS_OPTIONS}
                            icon={iconDiasGratis}
                        />
                    </ValidationMessage>

                    <div className="crear-negocio__button-container">
                        <Button
                            text={isLoading ? "GUARDANDO..." : "GUARDAR"}
                            className="degrad crear-negocio__submit-button"
                            type="submit"
                            disabled={isLoading}
                        />
                    </div>
                </form>
            </div>
            <Toaster />
        </CardView>
    );
};
export default CrearNuevoNegocio;
